<template>
    <header
        class="fixed w-full z-30 bg-white transition duration-300 ease-in-out border-b border-neutral-200 hover:bg-white/80 hover:backdrop-blur-sm hover:shadow-lg ">
        <div class="w-full px-2 lg:px-0">
            <div class="flex items-center justify-between h-11 lg:h-14 lg:pr-6 pr-0">
                <div class="flex items-center mr-4 lg:pl-8 text-xl">
                    <!-- <img width="22px" height="22px" src="@/assets/favicon.png" /> -->
                    <a class="pl-2 font-bold" aria-label="Cruip" :href="menus[0].path">
                         <span class="hidden lg:inline">中小非标机械厂</span>
                        <span class="relative whitespace-nowrap text-blue-600">
                            <svg aria-hidden="true" viewBox="0 0 418 42"
                                class="absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70"
                                preserveAspectRatio="none">
                                <path
                                    d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z">
                                </path>
                            </svg>
                            <span class="relative">ERP&MES</span>
                        </span> 一体化管理系统
                    </a>
                </div>
                <nav class="hidden lg:flex lg:grow" v-if="showMenu">
                    <div class="hidden md:flex md:gap-x-6 ml-32">
                        <a v-for="(item, index) in menus" :key="item.key" :class="[
                            activeIndex === index ? 'bg-blue-100 text-slate-900' : '',
                            'inline-block rounded-lg px-2 py-1 text-lg text-slate-700 hover:bg-blue-100 hover:text-slate-900'
                        ]" :href="item.path">{{ item.title }}</a>
                    </div>
                </nav>
                <div class="flex lg:hidden">
                    <a-icon type="menu" @click="showDrawer" />
                    <a-drawer placement="left" :visible="visible" @close="onClose">
                        <div class="flex flex-col w-3/4">
                            <a v-for="(item, index) in menus" :key="item.key" :class="[
                                activeIndex === index ? 'bg-blue-100 text-slate-900' : '',
                                'inline-block rounded-lg px-2 py-1 text-lg text-slate-700 hover:bg-blue-100 hover:text-slate-900'
                            ]" :href="item.path" @click="onClose">{{ item.title }}</a>
                        </div>
                    </a-drawer>
                </div>
                <a class="hidden lg:block" href="https://dev.imes.cloud" target="_blank">
                    <a-button type="primary" v-if="showMenu">演示登录</a-button>
                </a>
                <a class="lg:hidden" href="https://dev.imes.cloud" target="_blank">
                    <a-button size="small" type="primary" v-if="showMenu">演示登录</a-button>
                </a>
            </div>
        </div>
    </header>
</template>

<script>
// const prefixUrl = '/#';
const prefixUrl = '';

export default {
    name: 'homePageHeader',
    props: {
        // 具有默认值的数字
        showMenu: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            visible: false,
            menus: [
                { title: '首页', key: 'home', path: `${prefixUrl}/home` },
                { title: '产品功能', key: 'products', path: `${prefixUrl}/products` },
                { title: '客户案例', key: 'case', path: `${prefixUrl}/customer` },
                { title: '关于我们', key: 'about', path: `${prefixUrl}/about` },
            ]
        }
    },
    computed: {
        activeIndex() {
            const curIndex = this.menus.findIndex(m => m.path === `${prefixUrl}${this.$route.path}`);

            return curIndex !== -1 ? curIndex : 0;
        }
    },
    methods: {
        showDrawer() {
            this.visible = !this.visible;
        },
        onClose() {
            this.visible = false;
        },
    },
}
</script>
